const iff = (condition, then, otherwise) => {
    return (
        condition 
        ?
        then
        :
        otherwise
    );
};

export default iff;